import React from 'react';
import { BaasicInput, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { channelType } from 'common/constants';

const WarehouseCodesTemplate = ({
	t,
	viewStore: {
		loading,
		form,
		channel,
		parentViewStore: { editChannelWarehouseCodesModal, isEdit },
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('WAREHOUSECODES.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="row">
						<div className="col col-sml-12 col-med-6 spc--bottom--xsml">
							<div className="card card--xsml card--wh-codes">
								<label className="display--b type--xsml type--wgt--bold type--uppercase type--color--grey-3">
									{t('WAREHOUSECODES.SELLER')}
								</label>
								<p className="type--lrg type--wgt--bold">
									{channel || isEdit ? channel.seller.applicationTitle : '-'}
								</p>
							</div>
						</div>
						<div className="col col-sml-12 col-med-6 spc--bottom--xsml">
							<div className="card card--xsml card--wh-codes">
								<label className="display--b type--xsml type--wgt--bold type--uppercase type--color--grey-3">
									{t('WAREHOUSECODES.CHANNEL')}
								</label>
								<p className="type--lrg type--wgt--bold">{channel || isEdit ? channel.name : '-'}</p>
							</div>
						</div>
					</div>
					<div className="message message--tny message--primary spc--bottom--med">
						{/* Walmart uses ship node identifiers insted of warehouse codes, but they are equivalent. */}
						{(channel || isEdit) && channel.channelType.name === channelType.walmart
							? t('WAREHOUSECODES.WALMARTHINT')
							: t('WAREHOUSECODES.HINT')}
					</div>
					<table className="table--secondary table--secondary--warehouse spc--bottom--sml">
						<colgroup>
							<col />
							<col width="180" />
						</colgroup>
						<thead>
							{/* th value needs to be hardcoded. */}
							<tr>
								<th className="border">Warehouse</th>
								<th className="border">
									{(channel || isEdit) && channel.channelType.name === channelType.walmart
										? t('WAREHOUSECODES.SHIPNODEIDENTIFIER')
										: 'Code'}
								</th>
							</tr>
						</thead>
						<tbody>
							{form.$('warehouseCodes').map(item => {
								return (
									<tr key={item.id}>
										<td>
											<label className="type--base type--wgt--bold type--color--text">
												{item.$('warehouseName').value}
											</label>
										</td>
										<td>
											<BaasicInput noSpc field={item.$('name')} />
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--right--tny spc--bottom--sml" type="submit">
						{t('WAREHOUSECODES.SAVECODES')}
					</button>
					<button
						className="btn btn--med btn--outline spc--bottom--sml"
						onClick={() => editChannelWarehouseCodesModal.close()}
					>
						{t('CANCEL')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(WarehouseCodesTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/channel/pages/WarehouseCodesTemplate.jsx